export default Object.freeze({
  Pending: 1,
  RequiresAction: 2,
  Processing: 3,
  Paid: 4,
  Failed: 5,
  Cancelled: 6,
  Refunded: 7,
  PartiallyRefunded: 8,
});
